"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELLIPSIS_CHAR = exports.OPTIONS_PLACEHOLDER = exports.DEFAULT_STR = void 0;
exports.DEFAULT_STR = 'Non renseigné';
exports.OPTIONS_PLACEHOLDER = 'Choisissez une option';
exports.ELLIPSIS_CHAR = '…';
//# sourceMappingURL=constants.js.map